//
// Generated class OccupationRule
//

/// <reference path="OccupationRule_ManagedObject.ts" />

class OccupationRule extends OccupationRule_ManagedObject
{

}